import { render, staticRenderFns } from "./DeleteBadgeDialog.vue?vue&type=template&id=ac030b66&scoped=true&"
import script from "./DeleteBadgeDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteBadgeDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac030b66",
  null
  
)

export default component.exports